import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import Titlebar from "./components/Titlebar/Titlebar.js";
import { ContextProvider } from "./context/Provider.js";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: { 
    queries: { 
      refetchOnWindowFocus: false, 
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes - data is fresh for 5 minutes
    } 
  },
});

// Note: GET_ME query options are now handled in useGetMeQuery hook
// to ensure they only refetch when user is logged in

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Titlebar />
      <ContextProvider>
        <div className="h-screen">
          <App />
        </div>
      </ContextProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
